<template>
  <div>
    <div class="home">
      <div>
        <p class="home-span">SDK列表</p>
      </div>
    </div>
    <div class="box">
      <div>
        <p class="box-4" style="font-size:14px">SDK列表（Android版）</p>
        <p class="box-5">1. 我们使用了腾讯“Bugly”的SDK，功能是记录APP 运行期间的崩溃、异常信息并上传日志。使用到的权限是“存储权限、读取设备信息、读取网络状态、读取WIFI状态”，获取的用户信息是“个人常用设备信息”、“个人位置信息”。其中，“个人常用设备信息”、“个人位置信息”属于敏感信息。</p>
        <p class="box-5">2. 我们使用了腾讯“MTA”的SDK，功能是数据统计。使用到的权限是“读取设备信息、读取网络状态、读取WIFI状态”，获取的用户信息是“个人常用设备信息”、“个人位置信息”。其中，“个人常用设备信息”、“个人位置信息”属于敏感信息。</p>
        <p class="box-5">3. 我们使用了腾讯“微信登录分享”的SDK，功能是微信登录、微信分享。使用到的权限是“存储权限、读取设备信息、读取网络状态”。</p>
        <p class="box-5">4. 我们使用了华为“华为登录”的SDK，功能是华为设备快捷登录。使用到的权限时“读取设备信息、读取网络状态”。</p>
        <p class="box-5">5. 我们使用了极光“一键登录”的SDK，功能是手机号快捷登录。使用到的权限是“读取设备信息，读取网络状态”。</p>
        <p class="box-5">6. 我们使用了极光“极光推送”的SDK，功能是消息推送。使用到的权限是“存储权限、读取设备信息、读取网络状态、读取WIFI状态、震动权限”，获取的用户信息是“个人常用设备信息”、“个人位置信息”。其中，“个人常用设备信息”、“个人位置信息”属于敏感信息。</p>
        <p class="box-5">7. 我们使用了com.tencent.taisdk腾讯云智聆口语评测SDK，功能是使用麦克风及网络实现口语测评打分，使用的权限是麦克风权限及读取网络状态。</p>
        <p class="box-5">8. 我们使用了云知声SDK，功能是使用麦克风及网络实现口语测评打分，使用的权限是麦克风权限及读取网络状态。</p>
        <p class="box-5">9. 我们使用了io.agora(声网;agora)，功能是实现直播推流，提供实时音视频内容。使用的权限是读取网络状态。</p>
        <p class="box-5">10. 我们使用了即构SDK，功能是实现直播推流，提供实时音视频内容。使用的权限是读取网络状态。</p>
        <p class="box-5">11. 我们使用了百家云SDK，功能是实现直播推流，提供实时音视频内容。使用的权限是读取网络状态。</p>
        <p class="box-5">12. 我们使用了com.tencent.smtt腾讯云浏览器SDK功能是实现 学情数据展示，功能是腾讯云智聆口语评测分数展示。使用的权限是读取网络状态</p>
        <p class="box-5">13. 我们使用了MobTech SDK是实现社会化分享相关的功能，使用的权限是读取网络状态、外部文件读取权限、粗略定位权限</p>
        <p class="box-5">14. 我们使用了声通SDK，功能是使用麦克风及网络实现录音评测功能，帮助用户提升发音水平，使用的权限是麦克风权限及读取网络状态。</p>

        <p class="box-4" style="font-size:14px">SDK列表（IOS版）</p>
        <p class="box-5">1. 我们使用了腾讯“Bugly”的SDK，功能是记录APP 运行期间的崩溃、异常信息并上传日志。使用到的权限是“存储权限、读取设备信息、读取网络状态、读取WIFI状态”，获取的用户信息是“个人常用设备信息”、“个人位置信息”。其中，“个人常用设备信息”、“个人位置信息”属于敏感信息。</p>
        <p class="box-5">2. 我们使用了腾讯“微信登录分享”的SDK，功能是微信登录、微信分享。使用到的权限是“存储权限、读取设备信息、读取网络状态”。</p>
        <p class="box-5">3. 我们使用了极光“一键登录”的SDK，功能是手机号快捷登录。使用到的权限是“读取设备信息，读取网络状态”。</p>
        <p class="box-5">4. 我们使用了极光“极光推送”的SDK，功能是消息推送。使用到的权限是“存储权限、读取设备信息、读取网络状态、读取WIFI状态、震动权限”，获取的用户信息是“个人常用设备信息”、“个人位置信息”。其中，“个人常用设备信息”、“个人位置信息”属于敏感信息。</p>
        <p class="box-5">5. 我们使用了极光的“极光统计”SDK，功能是数据统计。使用到的权限是网络访问。</p>
        <p class="box-5">6. 我们使用了阿里“直播推流”的SDK，功能是将孩子上课信息进行直播上传到云端供家长监控和回看，使用到的权限是网络访问、录音采集、摄像头采集。</p>
        <p class="box-5">7. 我们使用了com.tencent.taisdk腾讯云智聆口语评测SDK，功能是使用麦克风及网络实现口语测评打分，使用的权限是麦克风权限及读取网络状态。</p>
        <p class="box-5">8. 我们使用了云知声SDK，功能是使用麦克风及网络实现口语测评打分，使用的权限是麦克风权限及读取网络状态。</p>
        <p class="box-5">9. 我们使用了io.agora(声网;agora)，功能是实现直播推流，提供实时音视频内容。使用的权限是读取网络状态。</p>
        <p class="box-5">10. 我们使用了即构SDK，功能是实现直播推流，提供实时音视频内容。使用的权限是读取网络状态。</p>
        <p class="box-5">11. 我们使用了百家云SDK，功能是实现直播推流，提供实时音视频内容。使用的权限是读取网络状态。</p>
        <p class="box-5">12. 我们使用了com.tencent.smtt腾讯云浏览器SDK功能是实现 学情数据展示，功能是腾讯云智聆口语评测分数展示。使用的权限是读取网络状态</p>
        <p class="box-5">13. 我们使用了MobTech SDK是实现社会化分享相关的功能，使用的权限是读取网络状态、外部文件读取权限、粗略定位权限</p>
        <p class="box-5">14. 我们使用了声通SDK，功能是使用麦克风及网络实现录音评测功能，帮助用户提升发音水平，使用的权限是麦克风权限及读取网络状态。</p>

      </div>
    </div>
  </div>
</template>

<script>
import "../css/home.css";
import rem from "../utils/rem";
export default {
  name: "Home",
  components: {},
};
</script>
